import { Spinner } from 'react-bootstrap';

export default function Loader() {
  return (
    <div className='overlay' aria-hidden='true'>
      <Spinner
        className='loading-spinner'
        animation='border'
        role='status'
      >
        <span className='sr-only'></span>
      </Spinner>
    </div>
  );
}